import { Component, OnInit, OnDestroy } from '@angular/core';
import { interval, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

interface Card {
  image: string;
  alt: string;
  text: string;
}

@Component({
  selector: 'app-publicy-cards',
  templateUrl: './publicy-cards.component.html',
  styleUrls: ['./publicy-cards.component.css']
})
export class PublicyCardsComponent implements OnInit, OnDestroy {
  cards: Card[] = [
    {
      image: 'assets/images/pet24-clasic-card-front.png',
      alt: 'Pet24 Classic Card',
      text: '¡Cuida a tu Mascota con Nuestra Exclusiva suscripción!'
    },
    {
      image: 'assets/images/pet24-gold-card-front.png',
      alt: 'Pet24 Gold Card',
      text: 'Descubre los beneficios Premium para tu mascota'
    },
    {
      image: 'assets/images/pet24-family-card-front.png',
      alt: 'Pet24 Family Card',
      text: 'Protege a toda tu familia de peluditos'
    }
  ];

  currentIndex: number = 0;
  private destroy$ = new Subject<void>();

  constructor() { }

  ngOnInit(): void {
    this.startCarousel();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private startCarousel(): void {
    interval(5000)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.nextCard();
      });
  }

  nextCard(): void {
    this.currentIndex = (this.currentIndex + 1) % this.cards.length;
  }

  prevCard(): void {
    this.currentIndex = (this.currentIndex - 1 + this.cards.length) % this.cards.length;
  }

  goToCard(index: number): void {
    this.currentIndex = index;
  }
}
